/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import useForm from "../../../hooks/useForm";
import { requiredFieldDefault, textFieldDefault } from "../../../services/validationRules";
import ValidatorTextField from "../../Validator/ValidatorTextField";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import _ from "lodash";
import { Box } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const IncomeDescriptive = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    incomeDescription: pcs.incomeDescription,
  };

  const { values, errors, handleChange, handleSubmit, handleBlur, registerValidators, touchedValues } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Wie bestreiten Sie Ihren Unterhalt?</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid size={12}>
            <ValidatorTextField
              label={"Wie bestreiten Sie Ihren Unterhalt?"}
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              placeholder={
                "Bitte beschreiben Sie hier kurz, warum Sie keine Einnahmen haben und wie Sie Ihren Unterhalt bestreiten."
              }
              name={"incomeDescription"}
              value={formValue(values, "incomeDescription")}
              onChange={handleChange}
              onBlur={handleBlur}
              registerValidators={registerValidators}
              validators={[...requiredFieldDefault, ...textFieldDefault]}
              error={!!errors["incomeDescription"]}
              helperText={errors["incomeDescription"]}
              multiline
              rows={"12"}
              maxRows={"12"}
              margin={"normal"}
              fullWidth
            />
          </Grid>
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default IncomeDescriptive;
